import { render, staticRenderFns } from "./chose_pay.vue?vue&type=template&id=395ca1da&scoped=true&"
import script from "./chose_pay.vue?vue&type=script&lang=js&"
export * from "./chose_pay.vue?vue&type=script&lang=js&"
import style0 from "./chose_pay.vue?vue&type=style&index=0&id=395ca1da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ca1da",
  null
  
)

export default component.exports